import { render, staticRenderFns } from "./Statistics_Users.vue?vue&type=template&id=3841229e&scoped=true&"
import script from "./Statistics_Users.vue?vue&type=script&lang=js&"
export * from "./Statistics_Users.vue?vue&type=script&lang=js&"
import style0 from "./Statistics_Users.vue?vue&type=style&index=0&id=3841229e&lang=scss&%2C=true&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3841229e",
  null
  
)

export default component.exports